<template>
</template>
<script>
    import bus from '@/utils/vueBus.js'
    import { mapState } from 'vuex'
    /**
     * @author: XMC
     * @description: 企微宝在线聊天webSocket核心工具
     * @demo: 在父组件直接使用：<web-web-socket-core :sock="sock"/>
     * sock 表示websocket对象
     */
export default {
    data () {
        return {
            wid: null,
            accountId: 0, // 0表示查询全部微信托管账户的数据，非0表示查询具体的微信托管账户数据
            sessionId: null,
            nowIndex: 0,
            nowList: [],
            count: 0,
            page: 1,
            pageSize: 10,
            noMoreData: false,
            sessionTypeIndex: 1, // 会话类型
            sessionSearch: '', // 搜索的会话
        }
    },
    props: ['sock'],
    // props: {
    //     // 接收sock对象
    //     sock: {
    //         type: WebSocket,
    //         default: () => null
    //     },
    // },
    computed: {
        ...mapState({
            pageCount: (state) => state.wxb.wxbPageCount, //每页多少条
            mySessionCurrentPage: (state) => state.wxb.wxbMySessionCurrentPage, // 我的 当前页码
            followSessionCurrentPage: (state) => state.wxb.wxbFollowSessionCurrentPage, // 别人分给我的会话 当前页码
            shareSessionCurrentPage: (state) => state.wxb.wxbShareSessionCurrentPage, // 我分给别人的会话 当前页码
            followSessionList: (state) => state.wxb.wxbFollowSessionList, //  别人分给我的会话列表
            shareSessionList: (state) => state.wxb.wxbShareSessionList, // 我分配的会话列表
            myAllSessionList: (state) => state.wxb.wxbMySessionList, // 我的会话列表
        }),
        tenancyId () {
            return this.$store.state.auth.tenancyId// 需要监听的tenancyId
        }
    },
    watch: {
        tenancyId (val) {
            // 监听租户ID，当租户ID变化时，才去连接websock
            if (val) {
                // 切换租户的时候需要清空缓存，切换缓存的时候可以放到fixedPage里面进行处理
                // this.$store.dispatch('setWxbClearOnlineCache')
            }
        },
        // 监听sock
        sock (val) {
            // 当sock对象不为空的时候才设置相关监听
            if (val) {
                // 暂时注解，这里仍然需要启用
                // bus.$emit('queryFollowSessionList')
                // 业务订阅成功后接受服务端推送消息
                // 这里只能用addEventListener 继续添加事件绑定。不能用onMessage进行绑定，因为该对对象已经添加过一次onMessage事件监听了，再次添加的时候会覆盖上一次的事件
                this.sock.addEventListener('message', (event) => {
                    const res = JSON.parse(event.data)
                    if (res) {
                        try {
                            // 登录成功，需要重新查询企微在线列表
                            /*if (res.code === 40001) {
                                bus.$emit('qwbloginListClose', res)
                                bus.$emit('getWxbPerson')
                            }*/
                            // 企微宝的企业微信在手机端主动退出PC端登录
                            /*if (res.code === 40002) {
                                console.log('收到40002,延迟执行', res)
                                bus.$emit('qwbloginListResult', res)
                                // 主动离线，需要重新查询企微在线列表
                                bus.$emit('getWxbPerson')
                            }*/
                            if (res.code === 420010) {

                            }
                            // 接收新消息
                            if (res.code === 42002) {
                                console.log('核心收到42002消息：', this.$route, res.data)
                                // 在聊天窗口才去调用聊天记录加1
                                if (this.$route.name === 'chatIndex') {
                                    bus.$emit('pushMsgList', res.data)
                                    // 未读消息加1
                                    bus.$emit('wxbUnReadMessageInCrease', res.data)
                                }
                                if (this.$route.name === 'sessionList') {
                                    // 查询会话列表
                                    bus.$emit('wxbQuerySession', res.data)
                                }
                            }
                            // 好友删除消息通知提醒，然后把该通知结果放在在线聊天页面，提示发送人对方已经删除你
                            if (res.code === 42004) {
                                console.log('接收22004：', res.data)
                            }
                            // 手机端已读消息，需要在pc端把该会话的未读消息重置为0
                            if (res.code === 42016) {
                                let value = { sessionId: res.data.id }
                                bus.$emit('wxbUnReadMessageInCrease', value)
                            }
                            // 接收“我的”会话列表
                            /*if (res.code === 410010) {
                                // this.$store.dispatch('setWechatTalkList', res.data)
                                console.log('接收410010我的：', res.data)
                                this.$store.dispatch('setWxbMySessionList', res.data.records)
                                this.$store.dispatch('setWxbMySessionPages', res.data.pages)
                            }*/
                            // 接收“我分配的”会话列表
                            /*if (res.code === 410030) {
                                console.log('接收410030我分配的：', res.data)
                                this.$store.dispatch('setWxbShareSessionList', res.data.records)
                                this.$store.dispatch('setWxbShareSessionPages', res.data.pages)
                            }*/
                            // 接收“别人分配给我的”会话列表
                            /*if (res.code === 410050) {
                                // 用户登录系统，但是还没授权登录微信时，去获取别人分配给我的会话列表，加入到“我的”
                                this.$store.dispatch('setWxbFollowSessionList', res.data.records)
                                this.$store.dispatch('setWxbFollowSessionPages', res.data.pages)
                            }*/
                            // 接收好友列表230010
                            /*if (res.code === 430010) {
                                this.$store.dispatch('setWxbFriendsList', res.data)
                            }*/
                            // 接收群列表230030
                            /*if (res.code === 430030) {
                                this.$store.dispatch('setWxbGroupChatList', res.data)
                            }*/
                            // 获取群成员数量
                            /*if (res.code === 430050) {
                                bus.$emit('wxbGetGroupNum', res.data)
                            }*/
                            // 分配会话之后，会话接收人的用户 接收本消息。取消分配也是推41006，然后重新查询“别人分配给我的”会话列表
                            if (res.code === 41006) {
                                bus.$emit('wxbRefreshSession')
                            }
                            // 跟进人收到41106消息或者分配人已经离线，然后重新查询41005别人分配给我的会话
                            if (res.code === 41106) {
                                bus.$emit('wxbRefreshSession')
                            }
                            // 分配会话给其他用户，获取服务器返回的数据“我分配的”
                            /*if (res.code === 410070) {
                                console.log('收到410070消息：', res)
                                bus.$emit('wxbQueryMySessionList') // 查询我的会话列表
                                bus.$emit('wxbQueryFollowSessionList') // 查询我分配的会话列表
                                bus.$emit('wxbQueryShareSessionList') // 查询别人分配给我会话列表
                            }*/
                            // 分配人登录或者下线，跟进人需要重新发41005
                            if (res.code === 41108) {
                                bus.$emit('wxbRefreshSession')
                            }
                            // 删除会话，置顶，取消置顶，免打扰，关闭免打扰, 更新会话时间
                            if (res.code === 410130 || res.code === 410150 || res.code === 410170 || res.code === 410190) {
                                // 刷新会话列表
                                bus.$emit('wxbRefreshSession')
                            }
                        } catch (e) {
                            console.error(e)
                        }
                    }
                })
            }
        }
    },
    mounted () {
        bus.$off('wxbSessionId')
        bus.$on('wxbSessionId', (value) => {
            this.sessionId = value.id
        })
        bus.$off('wxbOutonline')
        bus.$on('wxbOutonline', () => {
            let text = JSON.stringify({
                code: 40003,
                id: new Date().getTime(),
                data: {
                    accountId: this.accountId
                }
            })
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 获取分配人的对话框
        bus.$off('wxbShareWechat')
        bus.$on('wxbShareWechat', (value) => {
            if (value) {
                let text = JSON.stringify({
                    code: 41007,
                    id: new Date().getTime(),
                    data: {
                        sessionId: this.sessionId,
                        followers: value.followers,
                        accountId: value.accountId
                    }
                })
                if (this.sock !== null) {
                    this.sock.send(text)
                }
            }
        })
        // 发送维信聊天框的输入消息
        bus.$off('wxbSendText')
        bus.$on('wxbSendText', (value) => {
            let text = JSON.stringify({
                code: 42001,
                id: new Date().getTime(),
                data: value
            })
            console.log('发送42001消息：', text)
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 查询我的会话列表
        bus.$off('wxbQueryMySessionList')
        bus.$on('wxbQueryMySessionList', (param) => {
            if (param === undefined) {
                this.$store.commit('setWxbMySessionCurrentPage', 1)
                param = {
                    page: this.mySessionCurrentPage,
                    pageCount: this.pageCount,
                    keyword: ''
                }
            }
            let text = JSON.stringify({
                code: 41001,
                id: new Date().getTime(),
                data: {
                    accountId: this.accountId,
                    page: param.page,
                    pageCount: param.pageCount,
                    keyword: param.keyword || ''
                }
            })
            console.log('发送41001：', text)
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 查询别人分配给我的会话列表
        bus.$off('wxbQueryFollowSessionList')
        bus.$on('wxbQueryFollowSessionList', (param) => {
            if (param === undefined) {
                this.$store.commit('setWxbFollowSessionCurrentPage', 1)
                param = {
                    page: this.followSessionCurrentPage,
                    pageCount: this.pageCount,
                    keyword: ''
                }
            }
            let text = JSON.stringify({
                code: 41005,
                id: new Date().getTime(),
                data: {
                    page: param.page,
                    pageCount: param.pageCount,
                    keyword: param.keyword || ''
                }
            })
            console.log('发送41005：', text)
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 查询我分配给别人的会话列表
        bus.$off('wxbQueryShareSessionList')
        bus.$on('wxbQueryShareSessionList', (param) => {
            if (param === undefined) {
                this.$store.commit('setWxbShareSessionCurrentPage', 1)
                param = {
                    page: this.shareSessionCurrentPage,
                    pageCount: this.pageCount,
                    keyword: ''
                }
            }
            let text = JSON.stringify({
                code: 41003,
                id: new Date().getTime(),
                data: {
                    accountId: this.accountId,
                    page: param.page,
                    pageCount: param.pageCount,
                    keyword: param.keyword || ''
                }
            })
            console.log('发送41003：', text)
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 清空未读消息
        bus.$off('wxbClearUnRead')
        bus.$on('wxbClearUnRead', (sessionId) => {
            let text = JSON.stringify({
                code: 41011,
                id: new Date().getTime(),
                data: {
                    sessionId: sessionId
                }
            })
            console.log('发送41011：', text)
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 会话置顶
        bus.$off('wxbTopSession')
        bus.$on('wxbTopSession', (param) => {
            let text = JSON.stringify({
                code: 41017,
                id: new Date().getTime(),
                data: {
                    sessionId: param.sessionId,
                    sessionType: param.sessionType,
                    status: 1 // 置顶
                }
            })
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 会话取消置顶
        bus.$off('wxbCancelTopSession')
        bus.$on('wxbCancelTopSession', (param) => {
            let text = JSON.stringify({
                code: 41017,
                id: new Date().getTime(),
                data: {
                    sessionId: param.sessionId,
                    sessionType: param.sessionType,
                    status: 0 // 取消置顶
                }
            })
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 会话开启免打扰
        bus.$off('wxbUnDisturbSession')
        bus.$on('wxbUnDisturbSession', (param) => {
            let text = JSON.stringify({
                code: 41015,
                id: new Date().getTime(),
                data: {
                    sessionId: param.sessionId,
                    sessionType: param.sessionType,
                    status: 1 // 免打扰
                }
            })
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 会话关闭免打扰
        bus.$off('wxbCancelDisturbSession')
        bus.$on('wxbCancelDisturbSession', (param) => {
            let text = JSON.stringify({
                code: 41015,
                id: new Date().getTime(),
                data: {
                    sessionId: param.sessionId,
                    sessionType: param.sessionType,
                    status: 0 // 取消免打扰
                }
            })
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 删除会话
        bus.$off('wxbDelSession')
        bus.$on('wxbDelSession', (param) => {
            let text = JSON.stringify({
                code: 41013,
                id: new Date().getTime(),
                data: {
                    sessionId: param.sessionId,
                    sessionType: param.sessionType,
                }
            })
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 更新会话时间
        bus.$off('wxbUpdateSessionTime')
        bus.$on('wxbUpdateSessionTime', (param) => {
            let text = JSON.stringify({
                code: 41019,
                id: new Date().getTime(),
                data: {
                    sessionId: param.sessionId,
                    sessionType: param.sessionType,
                }
            })
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        // 企微宝获取群成员数量
        bus.$off('wxbSendGroupNumReq')
        bus.$on('wxbSendGroupNumReq', (contactId) => {
            let text = JSON.stringify({
                code: 43005,
                id: new Date().getTime(),
                data: {
                    contactId: contactId
                }
            })
            if (this.sock !== null) {
                this.sock.send(text)
            }
        })
        bus.$off('wxbUpdateAccountId')
        bus.$on('wxbUpdateAccountId', (accountId) => {
            this.accountId = accountId
        })
        bus.$off('getWxbPerson')
        bus.$on('getWxbPerson', (value) => {
            this.$http.get(`/scrm/v1/qw-account/m/findOnlineAccountList`).then((response) => {
                let { code, msg, data } = response
                if (code === 1) {
                    this.$store.dispatch('setWxbPerson', data)
                    if (data.length === 0) {
                        this.$store.dispatch('setWxbCurUser', null)
                    }
                } else {
                    this.$Notice.warning({
                        desc: msg
                    })
                }
            })
        })
        // 记录会话列表究竟是点击了，我的，别人给我，分给他人
        bus.$off('wxbSessionTypeIndex')
        bus.$on('wxbSessionTypeIndex', (val) => {
            this.sessionTypeIndex = val
        })
        bus.$off('wxbSessionSearch')
        bus.$on('wxbSessionSearch', (val) => {
            this.sessionSearch = val
        })
    },
}
</script>
